import { useGoalsStore } from "@/apps/goals/store/goalsStore";

export const useCurrentRegionName = () => {
  return useGoalsStore((state) => {
    const { initData } = state;
    const currentRegion = initData?.region_groups.find(
      (regionGroup) => regionGroup.id === initData.current_region_group_id
    );

    return currentRegion?.display_name ?? currentRegion?.name ?? null;
  });
};
